import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, vShow as _vShow, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "searchbox",
  class: "card"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row gx-3 align-items-center" }
const _hoisted_4 = { class: "col-auto mb-3" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "col-auto mb-3" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = { class: "row gx-3 align-items-center" }
const _hoisted_9 = { class: "col-auto mb-3" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-auto mb-3" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col-auto mb-3" }
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-auto mb-3" }
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "row gx-3 align-items-center" }
const _hoisted_22 = { class: "col-auto mb-3" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = { class: "col-auto mb-3" }
const _hoisted_25 = { class: "input-group" }
const _hoisted_26 = { class: "col-auto mb-3" }
const _hoisted_27 = { class: "input-group" }
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 0,
  class: "body-message"
}
const _hoisted_30 = {
  key: 1,
  class: "body-message"
}
const _hoisted_31 = {
  key: 2,
  class: "body-message"
}
const _hoisted_32 = {
  key: 3,
  class: "bursts-container"
}
const _hoisted_33 = {
  class: "modal",
  id: "graph-modal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "error-message",
  "aria-hidden": "true"
}
const _hoisted_34 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = { class: "modal-header" }
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = {
  class: "alert alert-danger alert-dismissible show rule-error",
  role: "alert"
}
const _hoisted_39 = {
  class: "modal",
  id: "graph-modal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "graph",
  "aria-hidden": "true"
}
const _hoisted_40 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "modal-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_batch_item = _resolveComponent("batch-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "card-header row" }, "Filter", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.get_bursts && _ctx.get_bursts(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "input-group-text" }, "From", -1)),
                _createVNode(_component_datepicker, {
                  modelValue: _ctx.pickerStartDate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pickerStartDate) = $event)),
                  typeable: "",
                  inputFormat: _ctx.dateFormat,
                  class: "input-sm form-control",
                  minimumView: "time",
                  onfocusout: _ctx.push_end_date()
                }, null, 8, ["modelValue", "inputFormat", "onfocusout"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "input-group-text" }, "To", -1)),
                _createVNode(_component_datepicker, {
                  modelValue: _ctx.pickerEndDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pickerEndDate) = $event)),
                  "lower-limit": _ctx.pickerStartDate,
                  typeable: "",
                  inputFormat: _ctx.dateFormat,
                  class: "input-sm form-control",
                  minimumView: "time"
                }, null, 8, ["modelValue", "lower-limit", "inputFormat"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "input-group-text" }, "Site", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "input-sm form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.site) = $event))
                }, [
                  _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, "-- All --", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: site,
                      key: site
                    }, _toDisplayString(site), 9, _hoisted_11))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.site]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "input-group-text" }, "Aggregator", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "input-sm form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.aggregator) = $event))
                }, [
                  _cache[17] || (_cache[17] = _createElementVNode("option", { value: "" }, "-- All --", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aggregators, (agg) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: agg,
                      key: agg
                    }, _toDisplayString(agg), 9, _hoisted_14))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.aggregator]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "input-group-text" }, "Node", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "input-sm form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.node_name) = $event))
                }, [
                  _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, "-- All --", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.node_names, (node) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: node,
                      key: node
                    }, _toDisplayString(node), 9, _hoisted_17))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.node_name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "input-group-text" }, "Sensor", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "input-sm form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.sensor_name) = $event))
                }, [
                  _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "-- All --", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensor_names, (sensor) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: sensor,
                      key: sensor
                    }, _toDisplayString(sensor), 9, _hoisted_20))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.sensor_name]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "input-group-text" }, "Batch ID", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "input-sm form-control",
                  id: "batch_id",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.batch_id) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.filters.batch_id]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "input-group-text" }, "Burst Limit", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "input-sm form-control",
                  id: "burst_limit",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.burst_limit) = $event)),
                  max: "1000",
                  min: "1",
                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.burst_limit_enforce_range && _ctx.burst_limit_enforce_range(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.filters.burst_limit]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "input-group-text" }, "Source", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "input-sm form-control",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.task_rule_id) = $event))
              }, [
                _cache[25] || (_cache[25] = _createElementVNode("option", { value: "null" }, "Raw data", -1)),
                _cache[26] || (_cache[26] = _createElementVNode("option", { value: "" }, "All data", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task_rules, (rule) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: rule.TaskRuleID,
                    key: rule
                  }, _toDisplayString(rule.Name), 9, _hoisted_28))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.filters.task_rule_id]
              ])
            ])
          ]),
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "form-row" }, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary"
            }, "Update Results")
          ], -1))
        ], 32)
      ])
    ]),
    _withDirectives(_createVNode(_component_loading_spinner, null, null, 512), [
      [_vShow, _ctx.isLoading]
    ]),
    (!_ctx.isLoading && _ctx.flatBursts.length < (_ctx.filters.burst_limit ? Number(_ctx.filters.burst_limit) : 1000))
      ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.flatBursts.length == 0 ? "No" : _ctx.flatBursts.length) + " " + _toDisplayString(_ctx.flatBursts.length == 1 ? "burst matches" : "bursts match") + " these filters. ", 1))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.flatBursts.length == (Number(_ctx.filters.burst_limit) || 1000))
      ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.filters.burst_limit) + " bursts are shown. There may be more bursts available - please narrow your filter. ", 1))
      : _createCommentVNode("", true),
    (_ctx.flatBursts.length != 0 && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_31))
      : _createCommentVNode("", true),
    (_ctx.batches.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batches, (batch) => {
            return (_openBlock(), _createBlock(_component_batch_item, {
              key: batch,
              batch: batch,
              plotGraph: _ctx.plotGraph,
              setToggleError: _ctx.setToggleError
            }, null, 8, ["batch", "plotGraph", "setToggleError"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _cache[31] || (_cache[31] = _createElementVNode("h5", { class: "modal-title" }, null, -1)),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[11] || (_cache[11] = 
                () => {
                  _ctx.errorMessage = '';
                }
              )
            }, [...(_cache[30] || (_cache[30] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _cache[32] || (_cache[32] = _createElementVNode("strong", null, "Error:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.errorMessage), 1)
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.errorMessage]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _cache[34] || (_cache[34] = _createElementVNode("h5", { class: "modal-title" }, null, -1)),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[12] || (_cache[12] = 
                () => {
                  _ctx.showGraphModal = !_ctx.showGraphModal;
                }
              )
            }, [...(_cache[33] || (_cache[33] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "modal-body" }, [
            _createElementVNode("div", { class: "chart-container" }, [
              _createElementVNode("div", {
                id: "graph",
                class: "graph"
              })
            ])
          ], -1))
        ])
      ])
    ], 512), [
      [_vShow, _ctx.showGraphModal]
    ])
  ]))
}